const updateCapacities = (capacity) => ({ 
    type: 'UPDATE_CAPACITIES', 
    capacity: capacity 
})

export { updateCapacities }
